import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthContext } from '../../contexts/AuthContext';
import styles from './UserMenu.module.css';

const UserMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { logoutUser } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSettings = () => {
        navigate('/settings');
        handleClose();
    };

    const handleLogout = async () => {
        await logoutUser();
        navigate('/');
        handleClose();
    };

    const open = Boolean(anchorEl);

    return (
        <div className={styles.menuWrapper}>
            <IconButton
                aria-label="user menu"
                onClick={handleOpen}
                className={styles.menuButton}
                size="large"
            >
                <ArrowDropDownIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={handleSettings}>
                    <SettingsIcon fontSize="small" className={styles.icon} />
                    Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <LogoutIcon fontSize="small" className={styles.icon} />
                    Logout
                </MenuItem>
            </Menu>
        </div>
    );
};

export default UserMenu;
